import React from 'react';
import useFormattingSettings from '../../hooks/useFormattingSettings';

const FormattedCurrency = ({ 
  value, 
  showSymbol = true, 
  style = {}, 
  className = "",
  currencyCode = null // Permite override da currency padrão
}) => {
  const { formatValue } = useFormattingSettings();
  
  if (!value && value !== 0) {
    return <span className={className} style={style}>-</span>;
  }
  
  const formattedValue = currencyCode 
    ? formatValue(value, showSymbol) 
    : formatValue(value, showSymbol);
    
  return (
    <span className={className} style={style}>
      {formattedValue}
    </span>
  );
};

export default FormattedCurrency;